import React from 'react';

function Key(props: object) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9184 14.3941C10.5153 13.3913 10.3096 12.3202 10.3125 11.2394C10.3125 6.71836 13.9547 2.96132 18.4734 2.81718C19.6278 2.77871 20.7777 2.97763 21.8521 3.40164C22.9264 3.82565 23.9022 4.46571 24.7191 5.28218C25.5361 6.09866 26.1766 7.07415 26.6012 8.14826C27.0258 9.22236 27.2254 10.3722 27.1875 11.5266C27.0387 16.0453 23.2816 19.6875 18.7605 19.6875C17.6798 19.6904 16.6087 19.4847 15.6059 19.0816L14.0625 20.625H11.25V23.4375H8.4375V26.25H4.6875C4.43886 26.25 4.2004 26.1512 4.02459 25.9754C3.84877 25.7996 3.75 25.5611 3.75 25.3125V21.9504C3.75012 21.7021 3.84874 21.464 4.02422 21.2883L10.9184 14.3941Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0938 7.5625C21.8359 7.5625 22.4375 8.16412 22.4375 8.90625C22.4375 9.64838 21.8359 10.25 21.0938 10.25C20.3516 10.25 19.75 9.64838 19.75 8.90625C19.75 8.16412 20.3516 7.5625 21.0938 7.5625Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.125"
      />
    </svg>
  );
}

export default Key;
